/* eslint-disable import/no-duplicates */
import fr from 'date-fns/locale/fr';
import zhCN from 'date-fns/locale/zh-CN';
import {
  format,
  getTime,
  differenceInDays,
  formatDistanceToNow,
  formatDistanceToNowStrict,
} from 'date-fns';

// ----------------------------------------------------------------------

export function fDifferenceDays(endDate: Date | number, startDate: Date | number) {
  return differenceInDays(endDate, startDate);
}

type DateType = Date | string | number;

export function fHours(date: DateType) {
  return format(new Date(date), 'HH');
}

export function fMinutes(date: DateType) {
  return format(new Date(date), 'mm');
}

export function fTime(date: DateType) {
  return `${fHours(date)}h${fMinutes(date)}`;
}

export function fDate(date: DateType, template = 'dd/MM/yyyy') {
  return format(new Date(date), template);
}

export function fDateTime(date: DateType, template = 'dd MMM yyyy p') {
  return format(new Date(date), template);
}

export function fTimestamp(date: DateType) {
  return getTime(new Date(date));
}

export function fDateTimeSuffix(date: DateType) {
  return format(new Date(date), 'dd/MM/yyyy hh:mm p');
}

export function fToNow(date: DateType, locale?: string) {
  return formatDistanceToNow(new Date(date), {
    addSuffix: true,
    locale: (locale === 'fr' && fr) || (locale === 'cn' && zhCN) || undefined,
  });
}

export function fToNowStrict(date: DateType, locale?: string) {
  return formatDistanceToNowStrict(new Date(date), {
    addSuffix: true,
    locale: (locale === 'fr' && fr) || (locale === 'cn' && zhCN) || undefined,
  });
}
